import { render, staticRenderFns } from "./rollForm.vue?vue&type=template&id=c7f47ae2&scoped=true&"
import script from "./rollForm.vue?vue&type=script&lang=js&"
export * from "./rollForm.vue?vue&type=script&lang=js&"
import style0 from "./rollForm.vue?vue&type=style&index=0&id=c7f47ae2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f47ae2",
  null
  
)

export default component.exports